import { render, staticRenderFns } from "./DepositStatusTagNew.vue?vue&type=template&id=29b08080&"
import script from "./DepositStatusTagNew.vue?vue&type=script&lang=js&"
export * from "./DepositStatusTagNew.vue?vue&type=script&lang=js&"
import style0 from "./DepositStatusTagNew.vue?vue&type=style&index=0&id=29b08080&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports